<template>
<div>

  <div class="header">
		<div class="header_main">
			<a href="../" class="logo"><img src="../../assets/images/login_logo.png" /></a>
			<span class="findpw">欢迎登录</span>
			<div class="header-phone">		  
          <span class="header-phone-top"><img src="../../assets/images/phone.gif">统一客服热线</span>
          <span class="header-phone-bottom">0579-88033333</span>
      </div>
    </div>
  </div>

  <div class="login-wrapper">
    <div class="login-content clearfix">
      <div class="login_left"><img src="../../assets/images/login_left.png"></div>
      <div class="login-form">
        <div class="login-wrap">
          <div class="login-tit">会员登录</div>
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="loginform" auto-complete="on" label-position="left">
              <el-form-item prop="username">
                <el-input ref="name" v-model="loginForm.username" autofocus="autofocus" name="username" type="text" prefix-icon="el-icon-user-solid" auto-complete="on" placeholder="请输入用户名" @keyup.enter.native="handleLogin" />
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="password" v-model="loginForm.password" name="password" auto-complete="on" placeholder="请输入密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleLogin" />
              </el-form-item>
              <el-form-item>
                <el-select v-model="loginForm.year" placeholder="请选择年度">
                  <el-option label="2023年" value="2023"></el-option>
                  <el-option label="2022年" value="2022"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="loading" @click.native.prevent="handleLogin" class="login_button">立即登录</el-button>
              </el-form-item>
              <div class="safety">
                <a class="forget-password" href="find-password.html">忘记密码？</a>
                <a class="new-register" href="find-password.html">新用户注册</a>
              </div>
            </el-form>
        </div>
      </div>
    </div>
  </div>

  <!-- 底部开始 -->
  <div class="login-footer">
    <div class="footer-info">
      <!-- 底部导航 -->
      <!--<p class="nav-bottom">
        <a href="#" target="_blank">公司概况</a>
        <em>|</em>
        <a href="#" target="_blank">产品与服务</a>
        <em>|</em>
        <a href="#" target="_blank">新闻动态</a>
        <em>|</em>
        <a href="#" target="_blank">自助服务</a>
        <em>|</em>
        <a href="#" target="_blank">客户服务</a>
        <em>|</em>
        <a href="#" target="_blank">联系我们</a>
      </p>-->
      <!-- 底部导航 -->
      <p>统一客服热线：0579-88033333   地址：浙江省金华市浦江县凤荷路89号</p>
      <p>浦江双胞胎快运服务有限公司 版权所有 <a href="http://beian.miit.gov.cn/" target="_blank" rel="nofollow">浙ICP备12027489号</a></p>
    </div>
  </div>
<!-- 底部结束 -->


</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Lockr from 'lockr'
import { Loading } from 'element-ui'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('密码不能小于5位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        year: '2023'
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      redirect: undefined,
      remember: false
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect  //自动跳转指定页面
      },
      immediate: true  //立即执行，而不是等到有变化时才执行
    },
    'loginForm.year': function (newVal) {
      if(newVal=='2023')
      {
        Lockr.set('system_version','2023')
      }
      else if(newVal=='2022')
      {
        Lockr.set('system_version','2022')
      }
      else
      {
        Lockr.set('system_version','2023')
      }
    }
  },
  computed: {},
  mounted() {
    Lockr.set('system_version','2023')
    //Lockr.set('year', this.loginForm.year)
  },
  methods: {
     handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.loginForm)
            .then(res => {
              this.loading = false
             // this.$router.push('/home');
              this.$router.push({ path: this.redirect || '/home' })
            })
            .catch(() => {
              this.loading = false
            })
        } 
        else 
        {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$dark_gray: #ccc;
$light_gray: #333;
$login_theme: #00aaee;

/*宽度*/
.w1200 { width: 1200px; margin: 0 auto;}
/*清除浮动*/
.clear { height: 0; overflow: hidden; clear: both;}
.clearfix:after { content: "."; display: block; height: 0; visibility: hidden; clear: both;}
/*头部*/
.header { min-width: 1200px; padding: 0; margin: 5px 0; overflow: hidden; border: 0; box-shadow: none;}
.header_main{ width:1200px; margin:auto;}
.header .logo{ float:left;}
.header .logo img { height:85px;}
.header .findpw { width: auto; height: 36px; padding: 0 15px; margin: 40px 0 0 10px; font-size: 24px; line-height: 44px; color: #333;float:left;}

.header-phone{ float:right; width:220px; margin-right:0px;}
.header-phone-top{ float:right; margin-top:5px; line-height:36px;font-size:18px;}
.header-phone-top img{ float:left; margin-top:5px; margin-right:10px;}
.header-phone-bottom{ float:right; margin-top:5px; font-size:24px; color:#f68121;}

/*中间*/
.login-wrapper {background-color: #389cf4; /*background: url(../img/logbg.jpg);*/background-size: cover;position: relative;min-height: 600px;}
.login-content{ width:1200px; margin:0 auto;}
.login_left{float:left;margin-left:100px;margin-top:80px;}
.login-form{width: 400px; overflow: visible; background: #fff; border-radius: 10px; float:right; margin-right:50px;margin-top:90px;}
.login-wrap{ width: auto; padding: 20px 40px; }
.login-wrap .login-tit { font-size: 20px; text-align:center; margin-bottom:30px; color:#389cf4;letter-spacing: 2px;}

.login-wrap .el-form {
      margin: 0px;padding:0px;
      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0 auto 50px;
        text-align: center;
      }
      .el-form-item{
            height: 50px;
      }
      .login_button {
        width: 320px;
        height: 45px;
        border-radius: 2px;
        font-size: 14px;
      
        margin-bottom: 20px;
        color: #fff;
        text-align: center;
        text-decoration: none;
        letter-spacing: 2px;
        cursor: pointer;
        border: none;
        background: #389cf4;
        outline: none;
      }
      .submit-btn {
        width: 100%;
        line-height: 2;
        font-size: 16px;
        color: white;
        border-radius: 3px;
        background-color: $login_theme;
        display: block;
      }
      .el-button {
        border: 0 none;
      }
}

// .form-control-box .icon, .login-wrap .form-group .form-control-error i, .login-content .login-form .msg-wrap .msg-icon, .login-wrap .item-coagent a i, .login-wrap .item-coagent a:hover i, .login-con .login-switch a, .login-mobile .default-state .qrcode-desc i {
//     background: url(../images/login-regiser-icon.png) no-repeat;
// }

.login-wrap .safety { height: 20px; margin-bottom: 15px; line-height: 20px; overflow: hidden;}
.login-wrap .safety label { cursor: pointer;}
.login-wrap .safety label .checkbox { margin: 0 3px 0 0; vertical-align: middle; cursor: pointer;}
.login-wrap .safety label span { vertical-align: middle; cursor: pointer;}
.login-wrap .safety .forget-password { float:left;margin-top: 3px; color:#389cf4;}
.login-wrap .safety .new-register { float:right; margin-top: 3px;color:#f68121;}

/*底部*/
.login-footer{ width:100%;/*background: #373d41;*/line-height: 1.8; padding:10px;box-sizing: border-box;}
.footer-info { width: 1200px; margin: 0 auto;font-size: 12px; text-align: center;color: #9b9ea0;}
.footer-info p{ height:28px; line-height:28px;}
.footer-info a {color: #9b9ea0;}

</style>
